export default "__VITE_ASSET__CQqUJOJB__"